/**
 * Returns the template use case string for a given customer invoice based on its type and status.
 * @function
 *
 * @param {Object} customerInvoice - The customer invoice object.
 * @param {string} customerInvoice.type - The type of the invoice (e.g., 'ADVANCE_PAYMENT', 'BALANCE', 'CREDIT_NOTE', 'SUBSCRIPTION').
 * @param {string} customerInvoice.status - The status of the invoice (e.g., 'WAITING', 'PAID', 'UNPAID').
 * @returns {string|null} The corresponding template use case string or null if not applicable.
 */
export const templateUseCase = (customerInvoice) => {
  if (!customerInvoice?.type || !customerInvoice?.status) return null;

  switch (customerInvoice.type) {
    case 'ADVANCE_PAYMENT':
      if (customerInvoice.status === 'WAITING')
        return 'OWNER_ADVANCE_INVOICE_WAITING';
      if (customerInvoice.status === 'PAID')
        return 'OWNER_ADVANCE_INVOICE_PAID';
      if (customerInvoice.status === 'UNPAID')
        return 'OWNER_ADVANCE_INVOICE_UNPAID';
      return null;
    case 'BALANCE':
      if (customerInvoice.status === 'WAITING') return 'OWNER_INVOICE_WAITING';
      if (customerInvoice.status === 'PAID') return 'OWNER_INVOICE_PAID';
      if (customerInvoice.status === 'UNPAID') return 'OWNER_INVOICE_UNPAID';
      return null;
    case 'CREDIT_NOTE':
      return 'CREDIT_NOTE';
    case 'SUBSCRIPTION':
      return `SUBSCRIPTION_INVOICE_${customerInvoice.status}`;
    default:
      return null;
  }
};
